import { useState } from 'react';

import { Trans, useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  Label,
  typographyVariants,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { useAtom } from 'jotai';

import { isAiHubWelcomeModalShownAtom } from '../../store/welcomeModal.js';
import poweredByAi from './poweredByAi.png';

const WelcomeModalDesktop = () => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const [isShown, setIsShown] = useAtom(isAiHubWelcomeModalShownAtom);
  const [isOpen, setIsOpen] = useState(isShown);

  const toggleIsShown = (e: boolean) => {
    setIsShown(!e); // `checked` prop
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog modal onOpenChange={onClose} open={isOpen}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot aria-describedby={undefined} size="xs">
          <DialogHeader>
            <DialogTitle>{t('Welcome to AI Hub')}</DialogTitle>
          </DialogHeader>
          <DialogContent className="flex flex-col gap-4">
            <img src={poweredByAi} alt="Powered by AI" />

            <Trans
              i18nKey="<Phrase>The MINT Agentic tools are <Bold>powered by AI</Bold></Phrase>"

              t={t}
              components={{
                Phrase: (
                  <div
                    className={cn(
                      'flex flex-row gap-1',
                      typographyVariants({
                        variant: 'bodyLong01',
                      }),
                    )}
                  />
                ),
                Bold: (
                  <div
                    className={typographyVariants({
                      variant: 'bodyLong02',
                    })}
                  />
                ),
              }}
            />

            <Label
              htmlFor="dont-show-again"
              variant="bodyLong01"
              className="flex flex-row gap-1"
            >
              <Checkbox
                id="dont-show-again"
                onCheckedChange={(e) => toggleIsShown(e as boolean)}
              />
              {t("Don't show this again")}
            </Label>
          </DialogContent>
          <DialogFooter>
            <Button variant="contained" size={'large'} onClick={onClose}>
              {t('I got it')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};

export { WelcomeModalDesktop };
